<div
  [id]="chipId"
  [ngClass]="{
    'selected': isChipSelected,
    'not-selected': !isChipSelected,
    'disabled': isChipDisabled,
    'not-disabled': !isChipDisabled,
  }"
  class="chip-container">
  <ng-content></ng-content>
</div>
